import { render, staticRenderFns } from "./edit-tab-filter.vue?vue&type=template&id=7389336c&scoped=true&"
import script from "./edit-tab-filter.vue?vue&type=script&lang=js&"
export * from "./edit-tab-filter.vue?vue&type=script&lang=js&"
import style0 from "./edit-tab-filter.vue?vue&type=style&index=0&id=7389336c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7389336c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSpacer})
